import { getActiveWorldConfig } from '@gamecodex/world-config'
import { Seo } from '@/components/Seo'
import { useT } from '@/i18n'

/**
 * "Coming soon — license restricted" gate. Rendered (footer only, no nav) for any
 * locale flagged `restricted` in `WorldConfig.locales` — the edition is fully
 * translated but its content can't ship in that market yet for licensing reasons.
 * Copy is localized (so an `/fr` visitor reads it in French); the page is noindex.
 */
export function LicenseGate() {
  const t = useT()
  const { worldName, branding } = getActiveWorldConfig()
  return (
    <>
      <Seo title={t('licenseGate.heading')} noIndex />
      <section className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 text-center">
        {branding?.images?.logo && (
          <img src={branding.images.logo} alt={worldName} className="mb-10 h-20 w-auto opacity-90" />
        )}
        <h1 className="font-display text-3xl leading-tight text-bone sm:text-4xl">
          {t('licenseGate.heading')}
        </h1>
        <p className="mt-5 font-body text-base text-bone-muted">{t('licenseGate.body')}</p>
      </section>
    </>
  )
}
